import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

export const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return useCallback(
    (path, options = {}) => {
      const currentParams = new URLSearchParams(search);
      const mobile = currentParams.get('mobile');
      const access = currentParams.get('access');

      let newPath = path;
      const [pathBase, pathQuery] = path.split('?');
      const newParams = new URLSearchParams(pathQuery || '');

      if (mobile && !newParams.has('mobile')) newParams.set('mobile', mobile);
      if (access && !newParams.has('access')) newParams.set('access', access);

      const queryString = newParams.toString();
      newPath = pathBase + (queryString ? `?${queryString}` : '');

      navigate(newPath, options);
    },
    [navigate, search]
  );
};
